exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box_info strong {\n  padding-bottom: 10px;\n}\n.box_info span {\n  padding-bottom: 10px;\n}\n.table th{\n  text-align: center;\n}\n.table td{\n  text-align: center;\n}\n.errors {\n  font-family: auto !important;\n  font-size: 13px;\n  font-style: italic;color: #f5222d;\n  float: left;\n  margin-top: 5px;\n}\n.form-group {\n  margin-bottom: 5px !important;\n}\n.cursor_pointer {\n  border: 1px solid;\n}\n.note {\n  padding-bottom: 10px;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  height: 44px;\n  line-height: 33px;\n}\n.center button {\n  border: unset !important;\n}\n.center button:focus {\n  border: unset !important;\n  outline: 0;\n}\na {\n  text-decoration: unset !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/evs/stamp_list/stamp-box/stamp-box.component.css
// module id = ../../../../../src/app/pages/admin/evs/stamp_list/stamp-box/stamp-box.component.css
// module chunks = 3